// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_-Cu","type":"styles_type__3fOIm","choices":"styles_choices__37ePb"};